import { Link } from 'react-router';
import { PageHeader } from '../components/ui';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page not found" description="That page doesn’t exist, or the link was copied incompletely." />
      <Link to="/" className="btn-secondary">
        Go to the schedule
      </Link>
    </>
  );
}
